import Accordion from 'src/components/section/Accordion';

export default function DownloadAccordion() {
  return (
    <Accordion subtitle="Download">
      <ul>
        <li>Click &quot;Options&quot;</li>
        <li>Click &quot;Asset Spreadsheet&quot; to download the asset excel file.</li>
        <li>This will download an excel document of your current assets to be modified</li>
      </ul>
    </Accordion>
  );
}
